export const navigation = {
  support: {
    question: "Brauchen Sie Hilfe?",
    whatsappCta: "Schreiben Sie uns auf WhatsApp",
  },
  alt: {
    whatsapp: "WhatsApp-Symbol",
    logo: "Dashboard-Logo",
  },
};
